import firebase from "firebase";
import "firebase/app";
import "firebase/auth";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDKTctmhw6lyCxxtb04xx2jERLriE_BIGQ",
  authDomain: "fishappproj.firebaseapp.com",
  databaseURL: "https://fishappproj-default-rtdb.firebaseio.com",
  projectId: "fishappproj",
  storageBucket: "fishappproj.appspot.com",
  messagingSenderId: "175974153365",
  appId: "1:175974153365:web:8995d08d6b523aa4a1af9c",
  measurementId: "G-6SQV7ZEXK5"
};

// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAzl0j8L2X8e-51_IrCW8Tp_Cx51o_FARU",
//   authDomain: "fishappproxy-d3fc9.firebaseapp.com",
//   projectId: "fishappproxy-d3fc9",
//   storageBucket: "fishappproxy-d3fc9.appspot.com",
//   messagingSenderId: "645470538865",
//   appId: "1:645470538865:web:ac1e016aa7d0f20ec09fd0",
//   measurementId: "G-LNG24Z42G8"
// };


// Initialize Firebase
firebase.initializeApp(firebaseConfig);

var database = firebase.database().ref("/");
var firestore =firebase.firestore();
var auth = firebase.auth();

export { firebase, firestore, database, auth };
